<template>
  <div class="flyingBook">
    <img v-if="this.class.options == 0" src="../../assets/images/failed@2x.png" alt="" />
    <img v-if="this.class.options == 1" style="width: 50px" src="../../assets/images/loading.gif" alt="" />
    <div v-if="this.class.options == 0">登录失败 请稍后重试</div>
    <div v-if="this.class.options == 2" style="width: 230px">
      <img style="width: 230px" src="../../assets/images/feishu_200x200@2x.png" alt="" />
      <div style="margin-top: 20px; font-size: 14px; color: #666666">请在外部浏览器打开该页面</div>
      <div style="margin-top: 16px; font-size: 12px; color: #999999">
        点击<span @click="openpage" style="color:rgb(64, 119, 232); cursor: pointer;"> 打开</span> 可在外部浏览器打开该页面
      </div>
    </div>
  </div>
</template>

<script>
import ApprovalClass from './ApprovalClass';

export default {
  components: {},
  data() {
    return {
      class: new ApprovalClass(),
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.class.initenv();
    this.class.flyingBookLogin();
  },
  methods: {
    openpage() {
      this.class.toProcessPage(1);
    },
  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;
  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
